var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWgNormalPriorityAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
    fill: "#EBE376",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.25C8.27614 7.25 8.5 7.47386 8.5 7.75V8.1516C8.5 8.21705 8.49358 8.28233 8.48082 8.34652L8.29159 9.29873C8.26834 9.41573 8.16567 9.5 8.04639 9.5H7.95495C7.83578 9.5 7.73318 9.41589 7.70981 9.29903L7.51942 8.3471C7.5065 8.28253 7.5 8.21684 7.5 8.15098V7.75C7.5 7.47386 7.72386 7.25 8 7.25ZM8 10.748C7.72441 10.748 7.5 10.5246 7.5 10.249C7.5 9.97341 7.72441 9.75 8 9.75C8.27559 9.75 8.5 9.97341 8.5 10.249C8.5 10.5246 8.27559 10.748 8 10.748Z",
    fill: "#ECAA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56237 3.36138C7.75155 3.01227 8.2526 3.01235 8.44167 3.36152L13.011 11.8004C13.1914 12.1335 12.9502 12.5385 12.5714 12.5385H3.42924C3.05032 12.5385 2.80911 12.1334 2.98963 11.8003L7.56237 3.36138Z",
    stroke: "#ECAA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWgNormalPriorityAlert);
export default __webpack_public_path__ + "static/media/wg-normal-priority-alert.67826946ced2ae17128f37e7f92170a2.svg";
export { ForwardRef as ReactComponent };